import './common'
import './searchPage';

if (typeof NodeList !== "undefined" && NodeList.prototype && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}


// WEBPACK FOOTER //
// ./src/desktop/scripts/index.js